import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';

export const posDeviceApi = createApi({
  reducerPath: 'posDeviceApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['posDevice'],
  endpoints: (builder) => ({
    saveDeviceData: builder.mutation({
      query(body) {
        return {
          url: spotFinder.POSDeviceDataController.saveDeviceData,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateDeviceData: builder.mutation({
      query(body) {
        return {
          url: spotFinder.POSDeviceDataController.updateDeviceData,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    getAllDeviceData: builder.mutation({
      query(body) {
        return {
          url: spotFinder.POSDeviceDataController.getAllDeviceData,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteDeviceData: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.POSDeviceDataController.deleteDeviceData}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

  }),
});

export const {
    useDeleteDeviceDataMutation,
    useGetAllDeviceDataMutation,
    useSaveDeviceDataMutation,
    useUpdateDeviceDataMutation
} = posDeviceApi;
